import { Properties } from '../Properties'
import axios from 'axios'

axios.defaults.withCredentials = true;
axios.defaults.headers.common["X-Requested-With"] = "JavaScript";

export const getUserInfo = () => axios.get(Properties.backendUrl + '/service/userinfo');

// Base authenticate URL - use getAuthenticateUrl(provider) for specific provider
export const authenticateUrl = Properties.backendUrl + '/service/callback';

/**
 * Get the authentication URL for a specific provider
 * @param {'google' | 'discord'} provider - The authentication provider ('google' or 'discord')
 * @returns {string} The full authentication URL with provider query parameter
 */
export const getAuthenticateUrl = (provider = 'google') => {
  const baseUrl = Properties.backendUrl + '/service/callback';
  return `${baseUrl}?provider=${encodeURIComponent(provider)}`;
};

export const authenticatedCallHelper = (serviceCall, successFunction, errorFunction) => serviceCall()
		.then((resp) => successFunction(resp))
		.catch((err) => {
	    	if (err.response && err.response.status == 499) {
							console.log("Redirecting to " + authenticateUrl);
	            window.location.assign(authenticateUrl);
	        } else if (errorFunction) {
	        	errorFunction(err);
	        }
		});

/**
 * Initiate login with a specific provider
 * @param {'google' | 'discord' | 'apple'} provider - The authentication provider
 */
export const logInWithProvider = (provider) => {
  const url = getAuthenticateUrl(provider);
  console.log(`Redirecting to ${provider} login: ${url}`);
  window.location.assign(url);
};

export const logIn = (successFunction) => authenticatedCallHelper(getUserInfo, successFunction);
export const logOut = (successFunction) => authenticatedCallHelper(() => axios.post(Properties.backendUrl + '/service/logout'), successFunction);

/**
 * Register a new user with the provided username
 * @param {string} username - The username for the new account (3-25 characters)
 * @returns {Promise} Axios promise with the created user object
 */
export const registerUser = (username) => {
  return axios.post(Properties.backendUrl + '/users/register', { username }, {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  });
};
